import React, { useEffect, useState } from 'react';
import '@tencentcloud/chat-uikit-react/dist/cjs/index.css';
import TIM, { ChatSDK } from 'tim-js-sdk/tim-js-friendship';
import TIMUploadPlugin from 'tim-upload-plugin';
import { getLatestUserSig, SDKAPPID } from '../config/tencent';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../redux/reducer/userProfile';
import { getUrlParam } from '../utils/utils';
import LiveLayout from '../components/LiveChat';
import { IS_IPHONE } from '../utils/environment';
import clsx from 'clsx';

export default function ContentLayout() {
  const [tim, setTim] = useState<ChatSDK>();
  const userID = `user_${getUrlParam('userId')}`;
  const roomID = getUrlParam('roomId');
  const dispatch = useDispatch();
  let muteUserIdList = [];
  const muteUserIdKey = `TUIPusher_${SDKAPPID}_${roomID}_${userID}_muteUserId`;
  // const userProfile = useSelector((state: RootState) => state.userProfile);

  useEffect(() => {
    (async () => {
      if (getUrlParam('userId') && getUrlParam('roomId')) {
        const tim = await init();
        setTim(tim);
        await dispatch(
          setCredentials({
            userID,
            userSig: (await getLatestUserSig(userID)).userSig
          })
        );
      } else {
        alert('Please add userId, roomId to param');
      }
    })();
  }, []);

  const init = async (): Promise<ChatSDK> => {
    return new Promise(async (resolve, reject) => {
      const tim = TIM.create({ SDKAppID: SDKAPPID });
      tim?.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin });
      const onReady = () => {
        resolve(tim);
      };
      tim.on(TIM.EVENT.SDK_READY, onReady);
      tim.login({
        userID,
        userSig: (await getLatestUserSig(userID)).userSig,
      });
    });
  };

  return (
    <div
      className={`layout-container ${clsx(IS_IPHONE && `is-iphone`)}`}
      style={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        background: '#000000d1',
        maxHeight: '100vh',
        overflow: 'hidden',
      }}
    >
      {getUrlParam('userId') && getUrlParam('roomId') && (
        <LiveLayout tim={tim} userID={userID} groupID={roomID} />
      )}
    </div>
  );
}
